module.exports = __webpack_public_path__ + "static/media/plus-add-new.8872139a.jpg";